import { Descriptor } from "./../vo/descriptor";
import { PresentationOption } from "./../vo/presentation-option";
import { Injectable } from "@angular/core";
import { BaseModel } from "./base-model";
import { HttpService } from "../../services/http.service";
import { Coursetitle } from "../vo/coursetitle";
import { LanguageOption } from "../vo/language-option";
import { LanguageAsset } from "../vo/language-asset";
import { CustomDoc } from "../vo/custom-doc";
import { DocBar } from "../vo/docBar";
import { retry ,  find } from "rxjs/operators";
import { TrackingManager } from "../tracking/tracking-manager";
import { UtilityScripts } from "../../helpers/utility-scripts";
import { GeoLocationModelService } from "../views/geolocation/geolocation.model.service";
import { Stream } from "stream";
import { ApplicationModel } from "./application.model";
import { AppConstants } from "../vo/app-constants";
@Injectable()
export class ConfigDocModelService extends BaseModel {
	private configXMLData: any;
	private arrCourseTitles: Coursetitle[] = [];
	private arrAvailableLanguages: LanguageOption[] = [];
	private arrSceneSelection: string[] = [];
	private arrChangeScenes: any[] = [];
	private _customDocs: CustomDoc[] = [];
	private arrPresentationModes: PresentationOption[] = [];
	private oDocBar: DocBar;
	private _flagList: any[];
	private _isAdaptive: boolean = false;
	private _skipTo: string = "";
	private _adaptiveLearningFlow: string = "";
	private _themingColors: any[];
	private _uniqueId: string;
	private _courseRevision: string;
	private _scorableMCQMaxPoints: number;

	constructor(
		private httpService: HttpService,
		private geoLocationService: GeoLocationModelService
	) {
		super();
	}

	public initialize(data: any) {
		this.loadConfigXML(data);
	}

	private loadConfigXML(url) {
		const configURL = url.split("?")[0];
		this.httpService.getXmlData(configURL).then((res: any) => {
			this.configXMLData = res;
			console.log(this.classname, this.configXMLData);
			this.parseConfig();
			this._notifier.next("data");
		});
	}

	private parseConfig(): void {
		this.parsePlayerTypeSkipToAndMCQMaxPoints();
		this.parseCourseTitles();
		this.parseLanguageOptions();
		this.setSceneSelection();
		this.parseCustomDocs();
		this.parsePresentationModes();
		this.parseDocBar();
		this.parseChangeScenes();
		this.parseFlags();
		this.parseTheme();
		this.parseUniqueId();
		this.parseCourseRevision();
	}

	private parsePlayerTypeSkipToAndMCQMaxPoints() {
		if (this.configXMLData.getElementsByTagName("playerType")[0]) {
			if (
				this.configXMLData
					.getElementsByTagName("playerType")[0]
					.textContent.toLowerCase() == AppConstants.ADAPTIVE
			) {
				this._adaptiveLearningFlow = AppConstants.ADAPTIVE;
				this._isAdaptive = true;
			} else if (
				this.configXMLData
					.getElementsByTagName("playerType")[0]
					.textContent.toLowerCase() == AppConstants.NON_ADAPTIVE ||
				this.configXMLData
					.getElementsByTagName("playerType")[0]
					.textContent.toLowerCase() == AppConstants.NONADAPTIVE
			) {
				this._adaptiveLearningFlow = AppConstants.NONADAPTIVE;
				this._isAdaptive = true;
			}
		}
		if (this.configXMLData.getElementsByTagName("skipTo")[0]) {
			if (
				this.configXMLData
					.getElementsByTagName("skipTo")[0]
					.textContent.toLowerCase() == AppConstants.SCENARIO ||
				this.configXMLData
					.getElementsByTagName("skipTo")[0]
					.textContent.toLowerCase() == AppConstants.END
			) {
				this._skipTo = this.configXMLData
					.getElementsByTagName("skipTo")[0]
					.textContent.toLowerCase();
			}
		}
		if (this.configXMLData.getElementsByTagName("scorableMCQMaxPoints")[0]) {
			this._scorableMCQMaxPoints = parseInt(this.configXMLData.getElementsByTagName("scorableMCQMaxPoints")[0].textContent);
		}
	}

	private parseCourseTitles(): void {
		const courseTitleDoc =
			this.configXMLData.getElementsByTagName("courseTitle");
		let courseTitle: Coursetitle;
		for (let x = 0; x < courseTitleDoc.length; x++) {
			courseTitle = new Coursetitle();
			courseTitle.title = courseTitleDoc[x].textContent;
			courseTitle.language = courseTitleDoc[x].getAttribute("language");
			this.arrCourseTitles.push(courseTitle);
		}
	}

	parseLanguageOptions() {
		const languageDoc =
			this.configXMLData.getElementsByTagName("languageOption");
		let languageOption: LanguageOption;
		const nLen = languageDoc.length;
		for (let x = 0; x < nLen; x++) {
			languageOption = new LanguageOption();
			languageOption.language = languageDoc[x].textContent;
			this.arrAvailableLanguages.push(languageOption);
		}
	}
	public get customDocs(): CustomDoc[] {
		return this._customDocs;
	}
	private parseCustomDocs() {
		//console.log(this.configXMLData);
		this._customDocs = [];
		const icons = Array.prototype.slice.call(
			this.configXMLData.getElementsByTagName("icon")
		);

		icons.forEach((doc) => {
			if (doc.getElementsByTagName("docTitle").length) {
				if (doc.getElementsByTagName("docTitle").length < 2) {
					let customDoc: CustomDoc = new CustomDoc();
					customDoc.language = doc.getAttribute("language");
					customDoc.docTitle =
						doc.getElementsByTagName("docTitle")[0].textContent;
					customDoc.iconTarget =
						doc.getElementsByTagName("iconTarget")[0].textContent;
					customDoc.iconTitle =
						doc.getElementsByTagName("iconTitle")[0].textContent;
					if (doc.getAttribute("geoLocation"))
						customDoc.geoLocation = doc.getAttribute("geoLocation");

					if (doc.getAttribute("mandatory")) {
						if (doc.getAttribute("mandatory") == "true")
							customDoc.isMandatory = true;
						else customDoc.isMandatory = false;
					} else customDoc.isMandatory = false;

					if (doc.getAttribute("printable")) {
						if (doc.getAttribute("printable") == "true")
							customDoc.isPrintable = true;
						else customDoc.isPrintable = false;
					} else customDoc.isPrintable = false;

					this._customDocs.push(customDoc);
				} else {
					let menuItem = doc.getElementsByTagName("menuItem");
					for (let i = 0; i < menuItem.length; i++) {
						let customDoc: CustomDoc = new CustomDoc();
						customDoc.language = menuItem[i].getAttribute("language");
						customDoc.docTitle =
							menuItem[i].getElementsByTagName("docTitle")[0].textContent;
						customDoc.iconTarget =
							menuItem[i].getElementsByTagName("iconTarget")[0].textContent;
						customDoc.iconTitle =
							menuItem[i].getElementsByTagName("iconTitle")[0].textContent;
						//
						if (menuItem[i].getAttribute("mandatory")) {
							if (menuItem[i].getAttribute("mandatory") == "true")
								customDoc.isMandatory = true;
							else customDoc.isMandatory = false;
						} else customDoc.isMandatory = false;

						if (menuItem[i].getAttribute("printable")) {
							if (menuItem[i].getAttribute("printable") == "true")
								customDoc.isPrintable = true;
							else customDoc.isPrintable = false;
						} else customDoc.isPrintable = false;
						//
						this._customDocs.push(customDoc);
					}
				}
			}
		});
	}

	private parsePresentationModes() {
		const pModes =
			this.configXMLData.getElementsByTagName("presentationOption");
		for (let x = 0; x < pModes.length; x++) {
			let pMode = new PresentationOption();
			if (
				pModes[0].getAttribute(`language`) &&
				pModes[0].getAttribute(`language`).includes(`,`)
			) {
				pMode.languageArr = pModes[0].getAttribute(`language`).split(`,`);
			}
			pMode.mode = pModes[x].textContent;
			this.arrPresentationModes.push(pMode);
		}
		if (pModes.length == 1) {
			ApplicationModel.instance.presMode = this.arrPresentationModes[0].mode;
		}

		this.setPresentationMode(this.arrPresentationModes[0].mode);
	}
	private parseChangeScenes() {
		const changeScenes = this.configXMLData.getElementsByTagName("sceneChange");
		let id = "";
		for (let x = 0; x < changeScenes.length; x++) {
			id = changeScenes[x].getAttribute(`id`);
			if (id) {
				this.arrChangeScenes.push({
					id: changeScenes[x].getAttribute(`id`),
					path: changeScenes[x].getAttribute(`path`),
				});
			}
		}
	}
	private parseFlags() {
		this._flagList = [];
		this.parsePrimaryFlags();
		this.parseSecondaryFlags();

		let flagVO;
		let countLen = this._flagList.length;
		for (let count = 0; count < countLen; ++count) {
			flagVO = this._flagList[count];
			if (flagVO.value != null && flagVO.value !== "") {
				UtilityScripts.pruneXMLNodes(
					this.configXMLData.childNodes[0],
					flagVO.id,
					flagVO.value
				);
			}
		}
	}
	private parsePrimaryFlags() {
		let flags = this.configXMLData.getElementsByTagName("flags")[0];
		let count = 0;
		let countLen = flags.childNodes.length;
		let flagVO;
		for (count = 0; count < countLen; ++count) {
			if (
				flags.childNodes[count].nodeName !== "#text" &&
				flags.childNodes[count].nodeName !== "#comment"
			) {
				flagVO = {};
				flagVO.id = flags.childNodes[count].nodeName;
				if (
					flags.childNodes[count].hasAttribute("any") &&
					flags.childNodes[count]
						.getAttributeNode("any")
						.nodeValue.toLowerCase() == "true" &&
					flagVO.id.toLowerCase() != "geolocation"
				) {
					//console.log("in iffff")
				} else {
					flagVO.value =
						flags.childNodes[count].textContent === null
							? null
							: flags.childNodes[count].textContent;
					if (
						flagVO.id.toLowerCase() === "geolocation" &&
						(flagVO.value === "" || flagVO.value === null)
					) {
						if (
							this.geoLocationService !== null &&
							this.geoLocationService.selectedGeoLocation
						) {
							flagVO.value = this.geoLocationService.selectedGeoLocation;
						} else {
							flagVO.value = TrackingManager.instance.trackingVO.geoLocation;
						}
					}
					if (flagVO.value !== "" && flagVO.value !== null) {
						this._flagList.push(flagVO);
						this._flagList[flagVO.id] = flagVO;
					}
				}
			}
		}
	}
	public get flagList() {
		return this._flagList;
	}
	private parseSecondaryFlags() {
		let secondaryFlags =
			this.configXMLData.getElementsByTagName("secondaryFlags")[0];
		let countLen = secondaryFlags ? secondaryFlags.childNodes.length : 0;
		let flagVO;
		for (let count = 0; count < countLen; ++count) {
			if (
				secondaryFlags.childNodes[count].nodeName !== "#text" &&
				secondaryFlags.childNodes[count].nodeName !== "#comment"
			) {
				flagVO = {};
				flagVO.id = secondaryFlags.childNodes[count].nodeName;
				if (secondaryFlags.childNodes[count].hasAttributes()) {
					let attr = secondaryFlags.childNodes[count].attributes[0];
					if (
						this._flagList[attr.nodeName] &&
						this._flagList[attr.nodeName].value &&
						attr.textContent.indexOf(
							this._flagList[attr.nodeName].value.toLowerCase()
						) !== -1
					) {
						flagVO.value =
							secondaryFlags.childNodes[count].textContent == null
								? null
								: secondaryFlags.childNodes[count].textContent;
					}
				} else {
					flagVO.value =
						secondaryFlags.childNodes[count].textContent == null
							? null
							: secondaryFlags.childNodes[count].textContent;
				}
				if (flagVO.value) {
					this._flagList.push(flagVO);
					this._flagList[flagVO.id] = flagVO;
				}
			}
		}
	}
	public getChangeScenesList() {
		return this.arrChangeScenes;
	}
	public getCourseTitles() {
		return this.arrCourseTitles;
	}

	public getLanguageOptions() {
		return this.arrAvailableLanguages;
	}

	public setLabelInLanguageOptions(languages: LanguageAsset[]): void {
		let langAsset: LanguageAsset;
		for (let i = 0; i < this.arrAvailableLanguages.length; i++) {
			langAsset = languages.find(
				(x) => x.lang === this.arrAvailableLanguages[i].language
			);
			if (langAsset) {
				if (langAsset.label)
					this.arrAvailableLanguages[i].label = langAsset.label;
				else this.arrAvailableLanguages[i].label = langAsset.lang;

				this.arrAvailableLanguages[i].direction = langAsset.direction;
				this.arrAvailableLanguages[i].langLabel = langAsset.langLabel;
				this.arrAvailableLanguages[i].langCode = langAsset.langCode
					? langAsset.langCode
					: "en-US"; //setting default langCode 'en-US'
			}
		}
	}

	private setSceneSelection() {
		for (
			let i = 0;
			i < this.configXMLData.getElementsByTagName("useScene").length;
			i++
		) {
			this.arrSceneSelection.push(
				this.configXMLData.getElementsByTagName("useScene").item(i).textContent
			);
		}
	}

	public getCourseTitle(language: string): string {
		return this.arrCourseTitles.find((x) => x.language === language).title;
	}

	public getCustomDocsForLanguage(language: string): CustomDoc[] {
		return this._customDocs.filter(
			(customDoc) => customDoc.language == language
		);
	}

	public get configXML(): any {
		return this.configXMLData;
	}

	public getDescriptorXMLPath(language: string): string {
		const arrDescDoc = Array.prototype.slice.call(
			this.configXMLData.getElementsByTagName("descDoc")
		);
		return arrDescDoc.find(
			(descDoc) => descDoc.getAttribute("language") == language
		).textContent;
	}
	public getDefinitionXMLPath(language: string): string {
		const arrDefDoc = Array.prototype.slice.call(
			this.configXMLData.getElementsByTagName("definitions")
		);
		return arrDefDoc.find(
			(defDoc) => defDoc.getAttribute("language") == language
		).textContent;
	}

	public get sceneSelection(): string[] {
		return this.arrSceneSelection;
	}

	public get structureDocPath(): string {
		return this.configXMLData.getElementsByTagName("structureDoc").item(0)
			.textContent;
	}

	public get menuXMLPath(): string {
		return this.configXMLData.getElementsByTagName("menuXMLpath").item(0)
			.textContent;
	}

	public get adaptiveXMLPath(): string {
		try {
			return this.configXMLData.getElementsByTagName("adaptiveXMLpath").item(0)
				.textContent;
		} catch (e) {}
	}

	public get availableGeoLocations() {
		return this.configXMLData.getElementsByTagName("availableLocations")
			.length > 0
			? this.configXMLData.getElementsByTagName("availableLocations")[0]
					.textContent
			: null;
	}

	public getLocationMenuXML(language: string) {
		const arr = Array.prototype.slice.call(
			this.configXMLData.getElementsByTagName("locationMenu")
		);
		return arr.find(
			(locationDoc) => locationDoc.getAttribute("language") === language
		).textContent;
	}
	public getStateSpecificContentXML(language: string) {
		const arr = Array.prototype.slice.call(
			this.configXMLData.getElementsByTagName("stateSpecificContent")
		);
		return arr.find(
			(stateContent) => stateContent.getAttribute("language") === language
		).textContent;
	}
	public get availableLanguages(): LanguageOption[] {
		return this.arrAvailableLanguages;
	}

	public updatePresentationModeName(txtFields: Descriptor[]) {
		this.arrPresentationModes.forEach((pMode) => {
			pMode.name = UtilityScripts.removeHTMLTags(
				this.getDescriptorTextByPresMode(txtFields, pMode.mode)
			);
		});
	}

	public get presentationModes(): PresentationOption[] {
		return this.arrPresentationModes;
	}

	public presentationModeUpdate(mode: string) {
		TrackingManager.instance.updateLessonLocation(
			AppConstants.PRESENTATION_MODE,
			mode
		);
		TrackingManager.instance.saveData(true);
		ApplicationModel.instance.presMode = mode;
	}

	public setPresentationMode(mode: string, type?) {
		this.arrPresentationModes.forEach((pMode) => {
			if (pMode.mode === mode) {
				pMode.selected = true;
			} else {
				pMode.selected = false;
			}
			var isDefaultHigh = (mode == 'high' && this.arrPresentationModes.some(value => value.mode == 'high'));
			var isDefaultMed = (mode == 'medium' && this.arrPresentationModes.some(value => value.mode == 'medium'));
			var isDefaultLow = (mode == 'low' && this.arrPresentationModes.some(value => value.mode == 'low'));
			if(type && !isDefaultHigh && !isDefaultMed && !isDefaultLow){
				if (mode == 'low' && pMode.mode == 'high' && !this.arrPresentationModes.some(value => value.mode == 'medium')){
					pMode.selected = true;
					this.presentationModeUpdate(pMode.mode);
				} else if (mode == 'low' && pMode.mode == 'medium'){
					pMode.selected = true;
					this.presentationModeUpdate(pMode.mode);
				} 
				if (mode == 'medium' && pMode.mode == 'high' && !this.arrPresentationModes.some(value => value.mode == 'low')){
					pMode.selected = true;
					this.presentationModeUpdate(pMode.mode);
				} else if ((mode == 'medium' && pMode.mode == 'low')){
					pMode.selected = true;
					this.presentationModeUpdate(pMode.mode);
				} 
				if (mode == 'high' && pMode.mode == 'medium' && !this.arrPresentationModes.some(value => value.mode == 'low')){
					pMode.selected = true;
					this.presentationModeUpdate(pMode.mode);
				} else if (mode == 'high' && pMode.mode == 'low'){
					pMode.selected = true;
					this.presentationModeUpdate(pMode.mode);
				}
			}
		});
	}

	public get uniqueId() {
		return this._uniqueId;
	}

	public get courseRevision() {
		return this._courseRevision;
	}

	private parseDocBar() {
		this.oDocBar = new DocBar();
		if (this.configXMLData.getElementsByTagName("docBar").length > 0) {
			const docBarNode = this.configXMLData.getElementsByTagName("docBar")[0];
			this.oDocBar.docBarLogo = docBarNode
				.getAttribute("docBarLogo")
				.replace(".swf", ".png");
			this.oDocBar.bgColor =
				docBarNode.getAttribute("bgColor") != undefined
					? docBarNode.getAttribute("bgColor")
					: this._isAdaptive
					? "#FFFFF7"
					: "#edecec";
			this.oDocBar.docBarHeight = "45px";
			this.oDocBar.title =
				docBarNode.getElementsByTagName("title").length > 0
					? docBarNode.getElementsByTagName("title")[0].textContent
					: "";
			this.oDocBar.subtitle =
				docBarNode.getElementsByTagName("subtitle").length > 0
					? docBarNode.getElementsByTagName("subtitle")[0].textContent
					: "";
			this.oDocBar.isDefault = false;
		} else {
			this.oDocBar.docBarLogo = "assets/ng_logo.svg";
			this.oDocBar.bgColor = "#f67e20";
			this.oDocBar.docBarHeight = "25px";
			this.oDocBar.title = "NAVEX GLOBAL";
			this.oDocBar.subtitle = "Ethics &amp; Compliance Training";
			this.oDocBar.isDefault = true;
		}
	}

	public get docBar(): DocBar {
		//console.log("this.oDocBar ",this.oDocBar);
		return this.oDocBar;
	}
	private getDescriptorTextByPresMode(
		txtFields: Descriptor[],
		presMode: string
	): string {
		const descriptor: Descriptor = txtFields.find(
			(item) =>
				item.additionalAttrs.length > 0 &&
				item.additionalAttrs[0].value === presMode
		);
		if (descriptor) {
			return descriptor.value;
		}
		return ``;
	}
	public get minimumTime() {
		if (this.configXMLData.getElementsByTagName("minimumTime").length > 0) {
			return this.configXMLData.getElementsByTagName("minimumTime")[0]
				.textContent;
		}
		return null;
	}
	public get maxPauseTime() {
		if (this.configXMLData.getElementsByTagName("maxPause").length > 0) {
			return this.configXMLData.getElementsByTagName("maxPause")[0].textContent;
		}
		return null;
	}
	public get isAdaptive() {
		return this._isAdaptive;
	}
	public get adaptiveLearningFlow() {
		return this._adaptiveLearningFlow;
	}
	public get skipTo() {
		return this._skipTo;
	}
	public get scorableMCQMaxPoints() {
		return this._scorableMCQMaxPoints;
	}
	public orientationXML(language: string): String {
		const orientationDoc = this.getOrientationDoc(language);
		if (orientationDoc) {
			const xmlUrl = Array.prototype.slice
				.call(orientationDoc.getElementsByTagName("xmlUrl"))
				.find(
					(xmlUrl) =>
						xmlUrl.getAttribute("profile") ===
						TrackingManager.instance.opProfile
				).textContent;
			return xmlUrl;
		}
	}
	public hasOrientation(language: string) {
		const orientationDoc = this.getOrientationDoc(language);
		let displayOrientation = true;
		if (orientationDoc && orientationDoc.getAttribute("display")) {
		  displayOrientation =
			(orientationDoc.getAttribute("display").toLowerCase() === "false")
			  ? false
			  : true;
		}
		return orientationDoc && displayOrientation ? true : false;
	  }

	private getOrientationDoc(language: string){
		const arrOrientationDoc = Array.prototype.slice.call(
			this.configXMLData.getElementsByTagName("orientationDoc")
		  );
		  const orientationDoc = arrOrientationDoc.find(
			(orientationDoc) => orientationDoc.getAttribute("language") === language
		  );
		  return orientationDoc;
	}
	public hasStateSpecificXML(language: string) {
		const arrStateSpecificXML = Array.prototype.slice.call(
			this.configXMLData.getElementsByTagName("stateSpecificContent")
		);
		const stateSpecificContent = arrStateSpecificXML.find(
			(stateSpecificXML) =>
				stateSpecificXML.getAttribute("language") === language
		);
		return stateSpecificContent ? true : false;
	}
	public isStateSpecificContentPresent() {
		if (
			this.configXML.getElementsByTagName("availableLocations").length > 0 &&
			this.configXML.getElementsByTagName("locationMenu").length > 0 &&
			this.configXML.getElementsByTagName("stateSpecificContent").length > 0
		) {
			return true;
		}
		return false;
	}
	private parseTheme() {
		this._themingColors = [];
		const customThemeNode: any = this.configXML.getElementsByTagName(
			"custom_theme"
		).length
			? this.configXML.getElementsByTagName("custom_theme")[0]
			: null;
		if (customThemeNode) {
			let nodes: any = Array.prototype.slice.call(customThemeNode.children);
			let coreColorNodes: any = nodes.filter(
				(item) => item.nodeName !== "font-colors"
			);
			let fontColorsNode: any = nodes.find(
				(item) => item.nodeName == "font-colors"
			);
			for (let item of coreColorNodes) {
				let colorObj: any = {};
				colorObj.type = item.nodeName; //primary-color
				colorObj.core_color =
					item.getElementsByTagName("core_color") &&
					item.getElementsByTagName("core_color").length
						? item.getElementsByTagName("core_color")[0].textContent.trim()
						: null;
				colorObj.core_color_b =
					item.getElementsByTagName("core_color_B") &&
					item.getElementsByTagName("core_color_B").length
						? item.getElementsByTagName("core_color_B")[0].textContent.trim()
						: null;
				colorObj.core_color_c =
					item.getElementsByTagName("core_color_C") &&
					item.getElementsByTagName("core_color_C").length
						? item.getElementsByTagName("core_color_C")[0].textContent.trim()
						: null;
				this._themingColors.push(colorObj);
			}
			if (fontColorsNode) {
				let colorObj: any = {};
				colorObj.type = fontColorsNode.nodeName; //font-color
				colorObj.core_color_a =
					fontColorsNode.getElementsByTagName("color_A") &&
					fontColorsNode.getElementsByTagName("color_A").length
						? fontColorsNode
								.getElementsByTagName("color_A")[0]
								.textContent.trim()
						: null;
				colorObj.core_color_b =
					fontColorsNode.getElementsByTagName("color_B") &&
					fontColorsNode.getElementsByTagName("color_B").length
						? fontColorsNode
								.getElementsByTagName("color_B")[0]
								.textContent.trim()
						: null;
				colorObj.core_color_c =
					fontColorsNode.getElementsByTagName("color_C") &&
					fontColorsNode.getElementsByTagName("color_C").length
						? fontColorsNode
								.getElementsByTagName("color_C")[0]
								.textContent.trim()
						: null;
				this._themingColors.push(colorObj);
			}
		}
	}

	public get theming_colors() {
		return this._themingColors;
	}

	private parseUniqueId() {
		let uniqueIdTag = this.configXMLData.getElementsByTagName("uniqueID")[0];
		this._uniqueId = uniqueIdTag ? uniqueIdTag.textContent : null;
	}

	private parseCourseRevision() {
		let courseRevTag =
			this.configXMLData.getElementsByTagName("courseRevision")[0];
		this._courseRevision = courseRevTag ? courseRevTag.textContent : null;
	}
}
